import gql from 'graphql-tag';

export const CREATE_PROJECT_DRAWER_PROJECT_QUERY = gql`
  query CreateProjectDrawerProject(
    $projectName: String!
    $entityName: String
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      name
      entityName
      access
      description
      user {
        id
      }
      entity {
        id
        isTeam
      }
    }
  }
`;
